import { FC } from 'react'
import { Card } from 'antd'
import PerText from '../Text'
import './index.less'
import { SmartAvatar } from '../../../modules/avatar/SmartAvatar'
import { useTranslation } from 'react-i18next'
import PerSpacer from '../Spacer'

type Props = {
  firstName: string
  lastName: string
  employeeId?: number
  noAvatar?: boolean
  nameType?: 'fullName' | 'firstName' | 'you'
  fullHeight?: boolean
  unknown?: boolean
}

export const PerCardWithAvatar: FC<Props> = ({
  children,
  employeeId,
  noAvatar,
  nameType = 'firstName',
  firstName,
  lastName,
  fullHeight,
  unknown = false,
}) => {
  const base = 'per-cardWithAvatar'
  const [t] = useTranslation()

  const renderName = () => {
    if (unknown) {
      return t('user.unknown.name')
    } else if (nameType === 'fullName') {
      return `${firstName} ${lastName}`
    } else if (nameType === 'firstName') {
      return firstName
    } else if (nameType === 'you') {
      return t('global.you')
    } else {
      return undefined
    }
  }

  return (
    <div className={base + (fullHeight ? ` ${base}-fullHeight` : '')}>
      <div className={base + '--avatar'}>
        {!noAvatar && employeeId && <SmartAvatar employeeId={employeeId} firstName={firstName} lastName={lastName} unknown={unknown} />}
      </div>
      <Card bordered={false}>
        {nameType && (
          <>
            <div style={{ height: 15, textAlign: 'center' }}>
              <PerText truncated appearance="subheading" display="block" color={unknown ? 'secondary' : undefined} fontSize="s">
                {renderName()}
              </PerText>
            </div>
            <PerSpacer mb="xs" />
          </>
        )}
        {children}
      </Card>
    </div>
  )
}
